import * as moment from 'moment';

export class InvoiceHistoryModel {
  public id: number;
  public clientId: number;
  public propertyId: number;
  public invoiceDate: Date;
  public invoiceNumber: number;
  public propertyName: string;
  public invoiceTotal: number;
  public amountPaid: number;
  public balance: number;
  public dueDate: Date;
  public locationName : string;
}

export enum InvoiceHistoryListDisplay {
  Client = 0,
  Property = 1
}

export class ClientInvoiceRow {
  public dateGenerated : Date;
  public clientName: string;
  public clientId: number;
  public clientLocationId: number;
  public invoiceNumber : number;
  public locationName : string;
  public totalAmount : number;
  public settledAmount : number;
  public balance : number;
  public dueDate : moment.Moment;
  public paymentResponseId: number;
}